import { deepClone } from '@/helper/lodashHelper';

export default {
  SET_CLASS_DATA(state, data) {
    state.classData = data;
  },
  SET_EDIT_CLASS_DATA(state, data) {
    state.classDataEdit = data;
  },
  SET_INIT_DATA(state, { type, data }) {
    const clone = deepClone(state.initData);
    clone[type] = { ...data };

    state.initData = clone;
  },
  UPDATE_EDIT_CLASSIFICATION(state, classification) {
    state.classDataEdit = deepClone(classification);
  },
  SET_EDIT_DELTA(state, delta) {
    state.classDataEditDelta = deepClone(delta);
  },
  RESET_EDIT(state) {
    state.classDataEdit = {};
    state.classDataEditDelta = {};
    state.initData = {};
  },
};
